/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  progress(id, params = {}) {
    return axios.get(`${this.url}/${id}/progress`, { params });
  }

  audienceCounts(ids) {
    return axios.get(`${this.url}/audience_counts`, { params: { ids } });
  }

  previewFilter(payload, channel) {
    return axios.post(`${this.url}/preview_filter`, { payload, channel });
  }

  previewLabels(labelIds, channel) {
    return axios.post(`${this.url}/preview_labels`, {
      label_ids: labelIds,
      channel,
    });
  }

  previewCsv(blobSignedId, channel) {
    return axios.post(`${this.url}/preview_csv`, {
      blob_signed_id: blobSignedId,
      channel,
    });
  }

  testSend(campaignId, recipients) {
    return axios.post(`${this.url}/${campaignId}/test_sends`, { recipients });
  }

  getContactVariables() {
    return axios.get(`${this.url}/contact_variables`);
  }

  variablePreview({ audience, variables, channel }) {
    return axios.post(`${this.url}/variable_preview`, {
      audience,
      variables,
      channel,
    });
  }

  reachableCountPreview(audience) {
    return axios.post(`${this.url}/reachable_count_preview`, { audience });
  }

  // Returns the CSV failures report attached to a campaign (rows that could not
  // be created because they lacked the campaign's channel field), or 404 if the
  // campaign has none attached.
  audienceFailuresCsv(campaignId) {
    return axios.get(`${this.url}/${campaignId}/audience_failures_csv`, {
      responseType: 'blob',
    });
  }

  deliveryFailuresCsv(campaignId) {
    return axios.get(`${this.url}/${campaignId}/delivery_failures_csv`, {
      responseType: 'blob',
    });
  }
}

export default new CampaignsAPI();
